import { BoxButton, TextButton } from '@riac/design-system';
import styled from 'styled-components';

const Col1Gap = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 1em;
`;

export const PhoneVerifyContainer = styled(Col1Gap)`
  padding-top: 2em;
`;

export const PhoneVerifyPrompt = styled(Col1Gap)``;

export const PhoneNumberDisplay = styled.h2`
  color: black;
  text-align: center;
`;

export const SendCodeButton = styled(BoxButton)`
  align-self: flex-start;
`;

export const PhoneVerifyResult = styled(Col1Gap)`
  ${TextButton} {
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
  }
`;

export const VerifyButton = styled(BoxButton)`
  align-self: flex-start;
`;

export const VerifySuccessMessage = styled.div`
  text-align: center;
  font-weight: bold;
`;
